import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography } from '@material-ui/core';
import { TabletButton } from '@campfire/tablet-button';

const DeleteFormDialog = ({
  open,
  formName,
  onClose,
  onConfirm,
}: {
  open: boolean;
  formName?: string;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  return (
    <Dialog open={open} maxWidth='sm' fullWidth>
      <DialogTitle>{`Delete ${formName}`}</DialogTitle>
      <DialogContent>
        <Typography>Are you sure you want to delete this form? Deleted forms are not recoverable.</Typography>
      </DialogContent>
      <DialogActions>
        <TabletButton variant='text' onClick={onClose}>
          Cancel
        </TabletButton>
        <TabletButton variant='text' color='error' onClick={onConfirm} autoFocus>
          Delete
        </TabletButton>
      </DialogActions>
    </Dialog>
  );
};

export { DeleteFormDialog };
